const AtomicBlockIdentifiers = {
  YOUTUBE_VIDEO: "youtube",
  IMAGE: "image",
  DIVIDER: "divider",
  GOOGLE_SPREADSHEET: "googleSpreadsheet",
  GOOGLE_FORMS: "googleForms",
  TYPEFORM: "typeform",
  AIRTABLE: "airtable",
  SIMPLECAST: "simplecast",
  SOCIAL_MEDIAS: "socialMedias",
  NEWSLETTER: "newsletter",
  CUSTOM_BUTTON: "customButton",
  GOVLAUNCH_PROJECT: "govlaunchProject",
};

export default AtomicBlockIdentifiers;
